// src/components/auth/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loader from '../common/Loader';

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Показываем загрузчик пока проверяется аутентификация
  if (loading) {
    return (
      <div className="suspense-loader" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh'
      }}>
        <Loader size="lg" />
      </div>
    );
  }

  // Если не аутентифицирован, перенаправляем на страницу входа
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location, showAuthMessage: true  }} replace />;
  }

  // Если аутентифицирован, показываем защищенный контент
  return <Outlet />;
};

export default ProtectedRoute;